// DOM lookup and the game canvas

/** querySelector for elements that index.html always has (the cast keeps call sites short) */
export const $ = <T extends HTMLElement = HTMLElement>(s: string) => document.querySelector(s) as T;
export const cv = $<HTMLCanvasElement>('#cv'), ctx = cv.getContext('2d')!;
